import React from "react";

const DownloadFont = () => {
  return (
    <div>
      {/* 
        information on downloading zeus lang 

        buttons for zeus lang wizard  */}
      download
    </div>
  );
};

export default DownloadFont;
